import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/adsStyle.js";


const useStyles = makeStyles(styles);

export default function Ads1() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center" >
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.container}>
            <div className={classes.title}>
              <h5>حامیان مسابقات ملی چالش های فناوری اطلاعات کشور</h5>
            </div>
          </div>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer justify="center" >
          <GridItem xs={12} sm={10} md={8}>
            <GridContainer justify="center" >
            <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://zaeim.com/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://rhsh.co.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i2.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  /></a>
                <br />
                <br />
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://www.refah-bank.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i3.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  /></a>
                <br />
                <br />
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://www.tejaratbank.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i4.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://www.behpaya.com/fa'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i5.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://pep.co.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i6.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://www.tourismit.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i7.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://asanpardakht.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i8.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://raybin.net/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i9.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://burna.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i10.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={3} sm={3} md={2}>
                <a target='_blank' href='https://faracloud.net/cloud-platform'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/i11.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
      
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
